var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "altasCrm" },
    [
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: {
            "padding-right": "0px",
            "padding-left": "10px",
            "padding-top": "15px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("DatePicker", {
                attrs: {
                  locale: "es-cl",
                  color: "primary",
                  label: _vm.titleStartDate
                },
                model: {
                  value: _vm.model_filtro_inicio,
                  callback: function($$v) {
                    _vm.model_filtro_inicio = $$v
                  },
                  expression: "model_filtro_inicio"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("DatePicker", {
                attrs: {
                  locale: "es-cl",
                  color: "primary",
                  label: _vm.titleEndDate
                },
                model: {
                  value: _vm.model_filtro_fin,
                  callback: function($$v) {
                    _vm.model_filtro_fin = $$v
                  },
                  expression: "model_filtro_fin"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Cliente",
                  "item-text": "nombre",
                  "item-value": "rut",
                  items: _vm.filtro_cliente,
                  clearable: "",
                  "prepend-icon": "account_circle"
                },
                model: {
                  value: _vm.model_filtro_cliente,
                  callback: function($$v) {
                    _vm.model_filtro_cliente = $$v
                  },
                  expression: "model_filtro_cliente"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.applyfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("search")
                    ]),
                    _vm._v("Filtrar")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: { "padding-right": "0px", "padding-left": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nombre Alta...",
                  clearable: "",
                  "prepend-icon": "description",
                  "append-icon": "search"
                },
                model: {
                  value: _vm.model_filtro_alta,
                  callback: function($$v) {
                    _vm.model_filtro_alta = $$v
                  },
                  expression: "model_filtro_alta"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nota de Venta...",
                  clearable: "",
                  "prepend-icon": "description",
                  "append-icon": "search"
                },
                model: {
                  value: _vm.model_filtro_nota,
                  callback: function($$v) {
                    _vm.model_filtro_nota = $$v
                  },
                  expression: "model_filtro_nota"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Serie...",
                  clearable: "",
                  "prepend-icon": "description",
                  "append-icon": "search"
                },
                model: {
                  value: _vm.model_filtro_serie,
                  callback: function($$v) {
                    _vm.model_filtro_serie = $$v
                  },
                  expression: "model_filtro_serie"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.cleanfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("clear")
                    ]),
                    _vm._v("Limpiar")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "v-card",
        [
          _c(
            "div",
            { staticClass: "gridcard rounded-card grilla_altas_crm" },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          ),
          _vm.AltaCrmModalState
            ? _c("ModalVerDetalleCrm", {
                attrs: {
                  show: _vm.AltaCrmModalState,
                  AltaCrm_Seleccionada: _vm.AltaCrm_Seleccionada,
                  NombreAlta: _vm.NombreAlta,
                  esEdicion: _vm.esEdicion
                },
                on: { cerrar: _vm.handleCierreModalAsignacion }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }